import { rangePresets } from '@gogame/intl-ts';
import { object, number, array, string } from '@gogame/schemas';

import {
  FILTER_PERIOD,
  FILTER_APPLICATIONS,
  FILTER_AFFILIATES,
  FILTER_EVENTS,
  PERIOD_PRESETS,
} from 'scenes/PostbacksReport/constants';

export const filtersSchema = object({
  [FILTER_PERIOD]: array(string()).constants(PERIOD_PRESETS).required(),
  [FILTER_APPLICATIONS]: array(number()),
  [FILTER_AFFILIATES]: array(number()),
  [FILTER_EVENTS]: array(number()),
}).default({
  [FILTER_PERIOD]: rangePresets.LAST_7_DAYS.value,
});

export const EMPTY_FILTERS = {
  ...filtersSchema.default(),
};
